// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import classNames from 'classnames';
import createReactClass from 'create-react-class';
import {Spec} from 'immutability-helper';
import PropTypes from 'prop-types';
import React from 'react';

import {EntryProtocol} from 'notebook/ELNConstants';
import wyciwyp from 'notebook/mediocre/clipboard/wyciwyp';
import EditableComponent from 'notebook/mediocre/core-ui/EditableComponent';
import EditableList from 'notebook/mediocre/selection/text/EditableListMixin';
// @ts-expect-error SelUtil still JS
import * as selutil from 'notebook/mediocre/selection/text/SelUtil';
import * as StepConstants from 'notebook/protocols/StepConstants';
import {ElementClipboardEvent} from 'util/Types';

const {EditorKey} = StepConstants;

const MAX_TITLE_LENGTH = 255;

interface TitleEditorProps {
  cid: string;
  protocol: EntryProtocol;
  jumpTo: (args: {
    section: StepConstants.EditorKey;
    row: 'first' | 'last';
    location: 'start' | 'end';
  }) => void;
  // required for mixing in EditableList, but not used within IntroEditor overrides
  metadataForRestore: {selection: BenchlingSelection | null};
  // omitted if locked
  updateProtocol?: (protocol: EntryProtocol, op: Spec<EntryProtocol>) => void;
  spellCheck: boolean;
}

interface TitleEditorState {
  index: number;
}

// oxlint-disable-next-line react/prefer-es6-class
export default createReactClass<TitleEditorProps, TitleEditorState>({
  propTypes: {
    cid: PropTypes.string.isRequired,
    protocol: PropTypes.object.isRequired,
    jumpTo: PropTypes.func.isRequired,
    updateProtocol: PropTypes.func, // omitted if locked
    spellCheck: PropTypes.bool.isRequired,
  },
  mixins: [EditableList],

  getInitialState() {
    return {
      index: 0,
    };
  },

  updateHandler(e: {text: string}): void {
    const {text} = e;
    if (text.length <= MAX_TITLE_LENGTH) {
      this.props.updateProtocol({name: text});
      this.props.requestSelection({selection: selutil.getSelectionIndices()});
    } else if (this._origSelection != null) {
      // forceContentEditableUpdate to reset component to show original text
      this.refs.contentEditable.forceContentEditableUpdate();
      this.props.requestSelection({selection: this._origSelection});
    }
  },

  pasteHandler(e: {before: string; after: string; originalEvent: ElementClipboardEvent}): void {
    const {before, after, originalEvent} = e;
    const parts = wyciwyp.processClipboard(originalEvent.clipboardData);
    const allowedPasteLength = MAX_TITLE_LENGTH - before.length - after.length;
    const pasteText = parts
      .map((part) => part.text)
      .join(' ')
      .slice(0, allowedPasteLength);
    const text = before + pasteText + after;
    const pos = text.length - after.length;

    this.props.updateProtocol({name: text});
    this.props.requestSelection({selection: {cid: this.props.cid, start: pos, end: pos}});
  },

  moveHandler(e: {up: boolean; beginning: boolean}): void {
    const {up, beginning} = e;
    if (!up) {
      this.clearSelection();
      const location = beginning ? 'start' : 'end';
      this.props.jumpTo({section: EditorKey.INTRO, location, row: 'first'});
    }
  },

  keyDownHook(): void {
    this._origSelection = selutil.getSelectionIndices();
  },

  render(): JSX.Element {
    return (
      <h1
        className={classNames({
          'mediocre-titleEditor': true,
          'is-locked': this.props.locked,
        })}
      >
        <EditableComponent
          // @ts-expect-error string refs only kinda sorta supported
          ref="contentEditable"
          cid={this.props.cid}
          text={this.props.protocol.name}
          index={this.state.index}
          moveHandler={this.moveHandler}
          updateHandler={this.updateHandler}
          pasteHandler={this.pasteHandler}
          storeState={this.props.storeState}
          restoreState={this.props.restoreState}
          keyDownHook={this.keyDownHook}
          locked={this.props.locked}
          spellCheck={this.props.spellCheck}
          allowRichText={false}
          allowMultiline={false}
        />
      </h1>
    );
  },
});
